'use client';

import { useTranslations } from 'next-intl';
import type { InsuranceProvider } from '@//app/api/commerce/insurance/provider/[id]';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Alert } from '@//components/Alert';
import { Logo } from '@//components/Logo';
import { WidgetHeading } from '../../WidgetHeading';
import IfInsurance from './IfInsurance';

interface InsuranceAdvancedProps {
  branchId: string;
  itemId: string;
  insuranceProvider: InsuranceProvider;
  vehicle: ElasticVehicle;
}

export const InsuranceAdvanced: React.FC<InsuranceAdvancedProps> = ({
  branchId,
  itemId,
  insuranceProvider,
  vehicle,
}) => {
  const t = useTranslations('pages.item.insuranceSection');

  switch (insuranceProvider.institute.toLowerCase()) {
    case 'if':
      // IfInsurance is a specific component for IF insurance provider
      return (
        <IfInsurance
          branchId={branchId}
          itemId={itemId}
          insuranceProvider={insuranceProvider}
          vehicle={vehicle}
        />
      );
    default:
      // Fallback for other insurance providers
      return (
        <>
          {insuranceProvider.logo && (
            <Logo
              src={insuranceProvider.logo}
              alt={insuranceProvider.title}
              width={120}
              height={48}
              logoSize="md"
            />
          )}
          <WidgetHeading id="insurance-heading">{t('calculateInsurance')}</WidgetHeading>
          <Alert id="alert-insurance-provider-not-supported" variant="info">
            {t('providerNotSupported', { provider: insuranceProvider.title })}
          </Alert>
        </>
      );
  }
};
